import React from 'react';
import { Box } from '@material-ui/core';
import FsVectorArrowIcon from 'ui-elements/icons/FsVectorArrow';
import cn from 'classnames';
import { FsSingleBarGraphDataProps } from 'ui-elements/charts/FsSingleBarGraph/FsSingleBarGraph';
import defaultLocales from 'globals/locales/default';
import { formatDate, slugify } from 'globals/utils';
import { useHistory } from 'react-router';
import Routes from 'routes';
import { TransactionType } from 'globals/types';
import FsIconButton from 'ui-elements/buttons/FsIconButton';
import BarGraphs from './BarGraphs';
import {
  Date,
  Category,
  GraphsBox,
  Price,
  PriceBox,
  Row,
  TextBox,
  Title,
} from './FsTransactionRowWithBarGraph.style-elements';
import { useStyles } from './FsTransactionRowWithBarGraph.style';

export interface FsTransactionRowWithBarGraphDataProps {
  title: string;
  category: string;
  date: number;
  price: string;
  id: number;
  graphs: FsSingleBarGraphDataProps[];
}

export interface FsTransactionRowWithBarGraphProps
  extends FsTransactionRowWithBarGraphDataProps {
  last: boolean;
  type: TransactionType;
}

const FsTransactionRowWithBarGraph: React.FC<FsTransactionRowWithBarGraphProps> = ({
  last,
  category,
  title,
  date,
  price,
  graphs,
  id,
  type,
}) => {
  const { lastRow } = useStyles();
  const history = useHistory();

  const handleClick = (): void => {
    const pathname = `${Routes.REPORT_MODAL_RECURRING_TRANSACTIONS}/${slugify(
      type
    )}/${id}`;

    history.push({
      pathname,
    });
  };

  return (
    <Row className={cn({ [lastRow]: last })}>
      <TextBox>
        <Box>
          <Title>{title}</Title>
          <Category>{category}</Category>
          <Date>{formatDate(date, true)}</Date>
        </Box>
        <PriceBox>
          <Price>{price}</Price>
        </PriceBox>
      </TextBox>
      <GraphsBox>
        <BarGraphs graphs={graphs} />
        <FsIconButton
          aria-label={defaultLocales.moreInfo}
          onClick={handleClick}
        >
          <FsVectorArrowIcon />
        </FsIconButton>
      </GraphsBox>
    </Row>
  );
};

export default FsTransactionRowWithBarGraph;
